export const REGISTER_Z_INDEX = 99
export const GRADIENT_Z_INDEX = 100
export const TABS_Z_INDEX = 101
export const NAVBAR_Z_INDEX = 102

export const SOCIAL_BUTTONS_Z_INDEX = 100

export const NOTIFICATION_Z_INDEX = 400

export const FEED_MEDIA_CONTAINER_Z_INDEX = 2
export const PROFILE_HEADER_Z_INDEX = 4

export const FEED_RODEO_PRODUCT_IMAGE_Z_INDEX = 1
export const FEED_RODEO_PRODUCT_BOOKMARK_Z_INDEX = 2
export const FEED_RODEO_PRODUCT_NON_MATCH_OVERLAY_Z_INDEX = 3

export const PRODUCT_DETAIL_IMAGE_Z_INDEX = 1
export const PRODUCT_DETAIL_ABOVE_IMAGE_Z_INDEX = 2

export const ROUNDUP_HEADER_Z_INDEX = 50
export const ROUNDUP_RIGHT_BAR_Z_INDEX = 2

export const RODEO_BUTTON_TUTORIAL_Z_INDEX = 300

export const MENU_CATEGORY_NAME_Z_INDEX = 1

export const EXPLORE_CREATOR_Z_INDEX = 1

export const CUSTOM_LINK_TEXT_Z_INDEX = 1

export const SUBSCRIBE_BUTTON_Z_INDEX = 1

export const MODAL_Z_INDEX = 300

export const CREATOR_AVATAR_Z_INDEX = 99

export const SHUFFLE_BUTTON_BACKGROUND_Z_INDEX = 1
export const SHUFFLE_BUTTON_VALUE_Z_INDEX = 2

export const INPUT_NAME_Z_INDEX = 10

export const VIDEO_PLAYER_CONTAINER_Z_INDEX = 1

export const PLAY_ICON_Z_INDEX = 2
